import Vue from 'vue'

import PageFrame from './PageFrame/index.vue'
import BottomBtn from './BottomBtns/index.vue'
import PageStable from './pageStable/index.vue'
import OffsetLine from './OffsetLine/index.vue'

Vue.component('page-frame', PageFrame)
Vue.component('bottom-btn', BottomBtn)
Vue.component('page-stable', PageStable)
Vue.component('offset-line', OffsetLine)
